import { useEffect, useState } from "react";

import { media } from "../../theme";

interface IMedia {
  mobile?: () => JSX.Element | null;
  tablet?: () => JSX.Element | null;
  laptop?: () => JSX.Element | null;
  desktop?: () => JSX.Element | null;
  only?: boolean;
  tabletOrDown?: () => JSX.Element | null;
  widerThanMobile?: () => JSX.Element | null;
}

/**
 * @deprecated
 */
export const isDownOfMobile = (): boolean =>
  window.innerWidth < media.size.mobile;

/**
 * @deprecated
 */
export const isWiderThanMobile = (): boolean =>
  window.innerWidth > media.size.mobile;

/**
 * @deprecated
 */
export const isTabletOrDown = (): boolean =>
  window.innerWidth < media.size.laptop;

/**
 * @deprecated
 */
export const isLaptopOrUp = (): boolean =>
  window.innerWidth >= media.size.laptop;

/**
 * @deprecated
 */
export const isMobile = (): boolean =>
  window.innerWidth >= media.size.mobile &&
  window.innerWidth < media.size.tablet;

/**
 * @deprecated
 */
export const isTablet = (): boolean =>
  window.innerWidth >= media.size.tablet &&
  window.innerWidth < media.size.laptop;

/**
 * Use useRenderOn hooks instead
 * @deprecated
 */
const RenderOn = ({
  mobile,
  tablet,
  laptop,
  desktop,
  only = false,
  tabletOrDown,
  widerThanMobile,
}: IMedia): JSX.Element | null => {
  const [width, setWidth] = useState(window.innerWidth);

  const updateWidth = (): void => setWidth(window.innerWidth);

  useEffect(() => {
    window.addEventListener("resize", updateWidth);

    return (): void => window.removeEventListener("resize", updateWidth);
  }, []);

  /**
   * Return a component only on the specified device
   */
  if (only) {
    return desktop && width >= media.size.desktop
      ? desktop()
      : laptop && width >= media.size.laptop && width < media.size.desktop
      ? laptop()
      : tablet && width >= media.size.mobile && width < media.size.laptop
      ? tablet()
      : mobile && width < media.size.mobile
      ? mobile()
      : null;
  }

  /**
   * Return a component on the specified device
   * and device with higher width
   */
  return (
    (desktop && width >= media.size.desktop
      ? desktop()
      : laptop && width >= media.size.laptop
      ? laptop()
      : tabletOrDown && width < media.size.laptop
      ? tabletOrDown()
      : tablet && width >= media.size.tablet
      ? tablet()
      : widerThanMobile && width >= media.size.mobile
      ? widerThanMobile()
      : mobile?.()) || null
  );
};

export default RenderOn;
